import React, { useState } from 'react'
import Tab from 'react-bootstrap/Tab'
import Tabs from 'react-bootstrap/Tabs'

import PlanTab from './plans'
import InvoicesAndReceipts from './invoices_receipts'
import Analytics from './analytics'
import SubscriptionHistory from './subscription_history'
import UserActivities from '../../user_activities/user_activities'
import CreditsAndLimits from './credits_and_limits'

import * as IndividualUserConstants from '../helpers/constant'
import * as Constants from '../../../helpers/constants'

const initialState = {
  key: 'credits_limits',
}

const TabsInfo = ({ userData, getUserInfo, client, userId, additionalUserData }) => {
  const [state, setState] = useState(initialState)

  const handleTabSelect = (key) => {
    setState((prevState) => ({ ...prevState, key: key }))
  }

  // since there is no way to load only active tab content
  // we have switch case to load only active tab content
  const getTabContent = (tab) => {

    // checking if the tab is active
    if (tab !== state.key)
      return null

    switch (tab) {
      case 'credits_limits': {
        return <CreditsAndLimits
          userData={userData}
          additionalUserData={additionalUserData}
          getUserInfo={getUserInfo}
          client={client}
        />
      }

      case 'plans': {
        return <PlanTab
          userData={userData}
          additionalUserData={additionalUserData}
          getUserInfo={getUserInfo}
          client={client}
        />
      }

      case 'subscription_history': {
        return <SubscriptionHistory
          userData={userData}
          getUserInfo={getUserInfo}
          client={client}
        />
      }

      case 'invoices_receipts': {
        return <InvoicesAndReceipts
          data={userData}
          getUserInfo={getUserInfo}
          client={client}
        />
      }

      case 'analytics': {
        return <Analytics
          client={client}
          userId={userId}
          userData={userData}
        />
      }
      case 'user_activities': {
        return <UserActivities
          userId={userId}
        />
      }
      default:
        return null
    }
  }

  return (
    <>
      <Tabs
        activeKey={state.key}
        onSelect={handleTabSelect}
        className="mb-3"
        fill
      >
        {
          IndividualUserConstants.TAB_SECTION[client]
            .map(tab =>
              Constants.DISPLAY_USER_ROLES[userData.user_role]
                .profile_tabs
                .includes(tab) ?
                <Tab
                  key={tab}
                  eventKey={IndividualUserConstants.TAB_KEY_AND_LABLE_MAPPING[tab].key}
                  title={IndividualUserConstants.TAB_KEY_AND_LABLE_MAPPING[tab].label}
                >
                  {getTabContent(tab)}
                </Tab>
                : null
            )
        }
      </Tabs>
    </>
  )
}

export default TabsInfo
